import React from "react";
import { Link } from "react-router";
import Dialog from "rc-dialog";
import Slider from "rc-slider";
import axios from "axios";

import Student from "../components/Student.js";
import Competence from "../components/Competence.js";
import MeasurementSlider from "../components/MeasurementSlider.js";
import MeasurementBundle from "../components/MeasurementBundle.js";
import SendResultsModal from "../components/SendResultsModal.js";
import { getDeep, isLoggedIn } from "../components/Utils";

class EventsMeasurements extends React.Component {
  constructor(props) {
    super(props);

    let currentEvent = this.props.events[this.props.params.eventId] !== undefined ? this.props.events[this.props.params.eventId] : {};

    this.state = {
      activeStudent: null,
      activeCompetence: null,
      dialogVisible: false,
      openStudents: false,
      openCompetences: false,
      competenceValue: 0,
      eventSliderValue: 0,
      eventSliderGlobalValue: 0,
      eventConfirmationPopup: false,
      currentEvent,
      courseExemptions: [],
      sendResultsDialogVisible: false
    };

    this.setActiveStudent = this.setActiveStudent.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.handleGlobalSlider = this.handleGlobalSlider.bind(this);
    this.handleOpenStudents = this.handleOpenStudents.bind(this);
    this.handleOpenCompetences = this.handleOpenCompetences.bind(this);
    this.updateCompetenceValue = this.updateCompetenceValue.bind(this);
    this.updateEventSliderValue = this.updateEventSliderValue.bind(this);
    this.updateEventSliderValueAfter = this.updateEventSliderValueAfter.bind(this);
  }

  closeDialog() {
    this.setState({
      dialogVisible: false
    });
  }

  handleOpenStudents() {
    this.setState({
      openStudents: !this.state.openStudents
    });
  }

  handleOpenCompetences() {
    this.setState({
      openCompetences: !this.state.openCompetences
    });
  }

  updateCompetenceValue(value) {
    this.setState({
      competenceValue: value
    });
  }

  handleGlobalSlider() {
    let value = this.state.eventSliderValue;
    let updateMeasurements = this.props.measurements[this.props.params.eventId];

    //let checkEx = this.state.courseExemptions.find((ex) => ex.end_term === endterm.end_term.uuid && ex.user === student.uuid && ex.course === currentEvent.course);
    let currentEvent = this.props.events[this.props.params.eventId];
    let skipMeasurements = [];

    if (currentEvent && currentEvent.event_roles) {
      currentEvent.event_roles.forEach((eventRole) => {
        eventRole.end_terms.forEach((endterm) => {
          endterm.competences.forEach((comp) => {
            comp.bundles.forEach((bundle) => {
              bundle.measurements.forEach((meas) => {
                Object.keys(updateMeasurements).forEach((studentId) => {
                  let checkEx = this.state.courseExemptions.find(
                    (ex) => ex.end_term === endterm.end_term.uuid && ex.user === studentId && ex.course === currentEvent.course
                  );
                  //this.props.updateMeasurement(this.props.params.eventId, studentId, meas.uuid, value);

                  if (!checkEx) {
                    this.props.updateMeasurement(this.props.params.eventId, studentId, studentId + "-comp-" + comp.competence.uuid, value);
                    this.props.updateMeasurement(this.props.params.eventId, studentId, meas.uuid, value);
                  }
                });
              });
            });
          });
        });
      });
    }

    this.setState({
      dialogVisible: false
    });
  }

  updateEventSliderValue(value) {
    this.setState({
      eventSliderGlobalValue: value
    });
  }

  updateEventSliderValueAfter(value) {
    if (value !== this.state.eventSliderValue) {
      this.setState({
        eventSliderValue: value,
        dialogVisible: true
      });
    }
  }

  setActiveStudent(studentId) {
    this.setState({
      activeStudent: studentId,
      openStudents: false
    });
  }

  setActiveCompetence(competenceId) {
    let competenceValue = this.state.competenceValue;

    this.setState({
      activeCompetence: competenceId,
      openCompetences: false,
      competenceValue
    });
  }

  componentWillMount() {
    if (!isLoggedIn()) {
      browserHistory.push("/");
      return;
    }

    this.props.fetchEventDetails(this.props.params.eventId);

    // Get all exemptions for this course
    axios
      .get(`/v1/events/${this.props.params.eventId}/exemptions/?pagination=false&fields=user,course,competence_profile,end_term`)
      .then((response) => {
        this.setState({
          courseExemptions: response.data
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentDidUpdate() {
    if (this.props.events !== undefined && this.props.events[this.props.params.eventId] === undefined) {
      this.props.fetchEventDetails(this.props.params.eventId);
    }
    if (!this.state.currentEvent) {
      this.props.fetchEventDetails(this.props.params.eventId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.events !== undefined && nextProps.events.length > 0) {
      let currentEvent = {};
      for (var i = 0; i < nextProps.events.length; i++) {
        if (nextProps.events[i].uuid == this.props.params.eventId) {
          currentEvent = nextProps.events[i];
        }
      }

      this.setState({
        currentEvent
      });
    }
  }

  render() {
    var openStudents = this.state.openStudents ? "event-students open" : "event-students";
    var openCompetences = this.state.openCompetences ? "event-competences open" : "event-competences";

    if (this.props.events.length === 0 || this.props.events[this.props.params.eventId] === undefined) {
      return (
        <div className="alert alert-info" key="uniquep">
          Ophalen van toetsmoment details...
        </div>
      );
    }

    let currentEvent = this.props.events[this.props.params.eventId];

    var studentRows = [];
    var competenceRows = [];
    var studentCompetences = [];
    var currentCompetence = {};
    var currentStudent = null;
    var noCompetences = false;
    var activeStudentId = this.state.activeStudent;
    var activeCompetenceId = this.state.activeCompetence;
    let competenceMeasurements = [];

    if (currentEvent.event_roles !== undefined) {
      currentEvent.event_roles.forEach((eventRole) => {
        // Calculate the values for each student based on the active competence
        let usedStudents = [];
        let competences = [];
        eventRole.students
          .filter((s) => !s.cancelled)
          .forEach((student) => {
            if (
              !usedStudents.includes(student.uuid) &&
              this.props.students &&
              this.props.students[currentEvent.uuid] &&
              this.props.students[currentEvent.uuid].includes(student.uuid)
            ) {
              let isActive = student.uuid === activeStudentId;
              if (currentStudent === null && activeStudentId === null) {
                activeStudentId = student.uuid;
                isActive = true;
              }

              // Check percentage
              let totalMeasurements = 0;
              let totalMeasurementsDone = 0;
              let tempObject = getDeep(this.props.measurements, this.props.params.eventId, student.uuid);

              // Get the measurements that are under the active student
              if (tempObject !== undefined && tempObject !== null) {
                Object.keys(tempObject).forEach((key) => {
                  // Check measurements with results
                  let checkUUID = key.toString();

                  if (!checkUUID.includes("bundle") && !checkUUID.includes("comp")) {
                    totalMeasurements++;

                    // Only mark a measurement as done if it has a result more than 0
                    if (tempObject[key] > 0) {
                      totalMeasurementsDone++;
                    }
                  }
                });
              }

              eventRole.end_terms.forEach((endterm) => {
                // Check for exemptions for this student
                let checkEx = this.state.courseExemptions.find(
                  (ex) => ex.end_term === endterm.end_term.uuid && ex.user === student.uuid && ex.course === currentEvent.course
                );
                if (checkEx) {
                  endterm.competences.forEach((comp) => {
                    comp.bundles.forEach((bundle) => {
                      totalMeasurements -= bundle.measurements.length;
                    });
                  });
                }
                endterm.competences.forEach((comp) => {
                  if (!competences.find((competence) => competence.uuid === comp.competence.uuid)) {
                    competences.push({
                      ...comp.competence,
                      bundles: comp.bundles
                    });
                  }
                });
              });

              let percentage = Math.round((totalMeasurementsDone / totalMeasurements) * 100);
              let studentRow = (
                <div
                  onClick={() => {
                    this.setActiveStudent(student.uuid);
                  }}
                  key={student.uuid}
                >
                  <Student
                    name={[student.first_name, student.last_name_prefix, student.last_name].filter(Boolean).join(" ")}
                    image={student.profile_image}
                    percentage={percentage}
                    isActive={isActive}
                    employerSpecific={(student.student_options || {}).employer_specific || false}
                  />
                </div>
              );
              studentRows.push(studentRow);

              studentCompetences[student.uuid] = competences;
              usedStudents[student.uuid] = true;

              // Check for current student
              if (isActive) {
                currentStudent = student;
              }
            }
          });

        // Check if we have the current active competence, or reset if needed
        let availableCompetences = [];
        eventRole.end_terms.forEach((endTerm) => {
          endTerm.competences.forEach((competence) => {
            let checkEx = this.state.courseExemptions.find(
              (ex) => ex.end_term === endTerm.end_term.uuid && ex.user === activeStudentId && ex.course === currentEvent.course
            );

            if (!checkEx) {
              availableCompetences.push(competence.competence.uuid);
            }
          });
        });
        if (!availableCompetences.includes(activeCompetenceId)) {
          activeCompetenceId = null;
        }

        eventRole.end_terms.forEach((endTerm) => {
          let checkEx = this.state.courseExemptions.find(
            (ex) => ex.end_term === endTerm.end_term.uuid && ex.user === activeStudentId && ex.course === currentEvent.course
          );

          if (!checkEx) {
            endTerm.competences.forEach((competence, i) => {
              let isActive = competence.competence.uuid === activeCompetenceId;

              if (
                activeCompetenceId === null &&
                competence.bundles.length &&
                competence.bundles[0].measurements &&
                competence.bundles[0].measurements.find((m) => m.measurement_type === "practice")
              ) {
                activeCompetenceId = competence.competence.uuid;
                isActive = true;
              }

              let totalMeasurements = 0;
              let totalMeasurementsDone = 0;

              // Build up the total amount of measurements and competences
              competence.bundles.forEach((bundle) => {
                bundle.measurements.forEach((measurement) => {
                  if (measurement.measurement_type === "practice") {
                    competenceMeasurements.push(measurement.uuid);
                    // Add one for the measurements to the total
                    totalMeasurements++;
                  }
                });
              });

              // Only show this competence if it has more than 1 practice measurement
              if (totalMeasurements > 0) {
                let latestScore = "";
                let tempObject = getDeep(this.props.measurements, this.props.params.eventId);
                if (tempObject !== undefined && tempObject !== null) {
                  Object.keys(tempObject).forEach((key) => {
                    Object.keys(tempObject[key]).forEach((key2) => {
                      // Check measurements with results
                      let checkUUID = key2.toString();

                      competence.bundles.forEach((bundle) => {
                        if (bundle.measurements.find((m) => m.uuid === checkUUID) && key === activeStudentId) {
                          // Only mark a measurement as done if it has a result more than 0
                          if (tempObject[key][key2] > 0) {
                            totalMeasurementsDone++;
                            latestScore = tempObject[key][key2];
                          }
                        }
                      });
                    });
                  });
                }

                // Calculate the percentage for this competence
                let percentage = Math.round((totalMeasurementsDone / totalMeasurements) * 100);
                let competenceRow = (
                  <div
                    onClick={() => {
                      this.setActiveCompetence(competence.competence.uuid);
                    }}
                    key={`${competence.competence.uuid} - ${i}`}
                  >
                    <Competence name={competence.competence.name} isActive={isActive} averageScore={latestScore} percentage={percentage} />
                  </div>
                );
                competenceRows.push(competenceRow);

                // Check for current competence
                if (isActive) {
                  currentCompetence = competence;
                }
              }
            });
          }
        });
      });

      if (competenceRows.length === 0) {
        let competenceRow = (
          <div key={`no-competences-${activeStudentId}`} className="no-results">
            Geen eindtermen om te toetsen
          </div>
        );
        competenceRows.push(competenceRow);
        noCompetences = true;
      }
    } else {
      // No data available yet, show the loading placeholders
      let competenceRow = <Competence key="0" name="Competenties ophalen..." percentage={0} isActive={false} />;
      competenceRows.push(competenceRow);

      let studentRow = <Student key="0" name="Cursisten ophalen..." percentage={0} isActive={false} />;
      studentRows.push(studentRow);
    }

    if (currentEvent.event_roles !== undefined) {
      var usedStudents = [];

      currentEvent.event_roles.forEach((eventRole) => {
        let competences = [];
      });
    }

    let measurementBundles = [];
    let linkedMeasurements = [];
    let linkedCompetenceMeasurements = [];
    if (currentCompetence.bundles !== undefined) {
      currentCompetence.bundles.forEach((bundle) => {
        linkedMeasurements = [];
        bundle.measurements.forEach((measurement) => {
          linkedMeasurements.push(measurement.uuid);
          linkedCompetenceMeasurements.push(measurement.uuid);
        });

        linkedMeasurements.push("bundle-" + activeStudentId + "-" + activeCompetenceId + "-" + bundle.uuid);
        linkedCompetenceMeasurements.push("bundle-" + activeStudentId + "-" + activeCompetenceId + "-" + bundle.uuid);

        measurementBundles.push(
          <MeasurementBundle
            {...this.props}
            uuid={"bundle-" + activeStudentId + "-" + activeCompetenceId + "-" + bundle.uuid}
            key={"bundle-" + activeStudentId + "-" + activeCompetenceId + "-" + bundle.uuid}
            title={bundle.name}
            hideSlider={true}
            student={currentStudent}
            description=""
            readonly={true}
            linkedMeasurements={linkedMeasurements}
            measurementSliders={bundle.measurements}
          />
        );
      });
    }

    if (activeStudentId === null) {
      var mainText = <p>Cursisten ophalen...</p>;
    } else if (noCompetences) {
      var mainText = (
        <div className="no-results">
          Deze cursist heeft geen competenties die afgetoetst kunnen worden.
          <br />
          Waarschijnlijk heeft deze cursist vrijstellingen voor alle af te nemen competenties.
        </div>
      );
    } else if (activeCompetenceId === null) {
      var mainText = <p>Competenties ophalen...</p>;
    } else {
      let compValue = 0;
      let getCompValue = getDeep(
        this.props.measurements,
        [this.props.params.uuid],
        [currentStudent.uuid],
        [activeStudentId + "-comp-" + currentCompetence.competence.uuid]
      );
      if (getCompValue) {
        compValue = getCompValue;
      }

      var mainText = (
        <div>
          <div className="measurement-description">
            <div className="measurement-description-row">
              <div className="measurement-description-label">Competentie</div>
              <div className="measurement-description-text">{currentCompetence.competence.name}</div>
            </div>
            <div className="measurement-bundle">
              <div className="measurement-description-label">
                <p className="lighter">O = Onvoldoende - VVV = Voor verbetering vatbaar - V = Voldoende - G = Goed</p>
              </div>

              <MeasurementSlider
                {...this.props}
                student={currentStudent}
                uuid={activeStudentId + "-comp-" + currentCompetence.competence.uuid}
                key={activeStudentId + "-comp-" + currentCompetence.competence.uuid}
                linkedMeasurements={linkedCompetenceMeasurements}
                callbackParent={this.updateCompetenceValue}
              />
            </div>
          </div>

          <div className="measurement-description-label alert alert-warning">
            Hieronder staan de toetsingen die binnen deze competentie vallen, die je op dit moment nog niet afzonderlijk kan beoordelen. In een volgende fase wordt het
            wel mogelijk om ook de toetsingen apart te beoordelen.
          </div>

          <div className="measurement-description-label">Toetsingen</div>

          {measurementBundles.length > 0 ? measurementBundles : <p>Deze competentie bevat geen toetsingen.</p>}

          <div className="event-detail-buttons">
            <Link to={"/events/" + this.props.params.eventId}>
              <button className="btn btn-primary">
                <i className="fa fa-chevron-left"></i>
                <span className="button-description">Terug naar het overzicht</span>
              </button>
            </Link>
          </div>
        </div>
      );
    }

    let values = ["Niet beoordeeld", "Onvoldoende", "Voor verbetering vatbaar", "Voldoende", "Goed"];
    let confirmationText = "Weet je zeker dat je alle cursisten wilt beoordelen als '" + values[this.state.eventSliderValue] + "'?";

    return (
      <div>
        <div className="event-main-title">
          <div className="event-label">Deze competenties zijn onderdeel van het competentieprofiel</div>
          <h1>{currentEvent.name}</h1>
        </div>
        <div className="event-global-slider-trigger" onClick={() => this.setState({ dialogVisible: true })}>
          <p>Alle cursisten en hun competenties in één keer beoordelen?</p>
          <span className="btn btn-tertiary">Klik hier</span>
        </div>
        <div className="event-detail">
          <div className={openStudents}>
            <div className="student-dropdown" onClick={this.handleOpenStudents}>
              <i className="fa fa-chevron-down"></i>
            </div>
            <div className="event-global-slider-trigger-desktop" onClick={() => this.setState({ dialogVisible: true })}>
              <p>Alle cursisten en hun competenties in één keer beoordelen?</p>
              <span className="btn btn-tertiary">Klik hier</span>
            </div>

            <div className="event-buttons">
              <Link to={"/events/" + this.props.params.eventId}>
                <button className="btn btn-tertiary">
                  <i className="fa fa-chevron-left"></i>&nbsp;
                  <span className="button-description">Overzicht</span>
                </button>
              </Link>

              <button className="btn btn-tertiary" onClick={() => this.setState({ sendResultsDialogVisible: true })}>
                <span className="button-description">Insturen resultaten</span>
                <i className="fa fa-chevron-right"></i>&nbsp;
              </button>
            </div>

            <div className="event-label event-students-label">Cursisten</div>
            {studentRows}
          </div>
          <div className={openCompetences}>
            <div className="competence-dropdown" onClick={this.handleOpenCompetences}>
              <i className="fa fa-chevron-down"></i>
            </div>
            {competenceRows}
          </div>
          <div className="event-measurements">{mainText}</div>
        </div>

        <Dialog title="Alle cursisten beoordelen" onClose={this.closeDialog} animation="fade" visible={this.state.dialogVisible} key="studentmeasurementsglobal">
          <p>
            Afzonderlijke beoordelingen overslaan? Dan kun je met deze knop alle resultaten in één keer op één en dezelfde beoordeling zetten.
            <br />
            Let op, dit overschrijft ook al je eerdere beoordelingen.
          </p>

          <div className="event-main-slider-container">
            <Slider
              min={0}
              max={4}
              marks={{
                0: "",
                1: "O",
                2: "VVV",
                3: "V",
                4: "G"
              }}
              value={this.state.eventSliderGlobalValue}
              onChange={this.updateEventSliderValue}
              onAfterChange={this.updateEventSliderValueAfter}
            />
          </div>
          <button type="button" className="btn btn-tertiary" key="save" onClick={this.handleGlobalSlider}>
            Beoordeling toepassen
          </button>
        </Dialog>

        <SendResultsModal closeDialog={() => this.setState({ sendResultsDialogVisible: false })} dialogVisible={this.state.sendResultsDialogVisible} {...this.props} />
      </div>
    );
  }
}

export default EventsMeasurements;



// WEBPACK FOOTER //
// ./pages/EventsMeasurements.js